import { css } from 'lit';

export default css`
  .content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
  }

  .layout {
    width: 47%;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.5px solid var(--amityeko-color-gray-8);
    border-radius: var(--amityeko-radius-large);
    cursor: pointer;
    box-sizing: border-box;
  }

  .layout__content {
    width: 120px;
    height: 120px;
    display: flex;
    flex-wrap: wrap;
  }

  /** Layout SQUARE CSS */
  .layout--square .layout__box {
    width: 100%;
    height: 100%;
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  /** Layout CIRCLE CSS */
  .layout--circle .layout__box {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  /** Layout SQUARE-3H CSS */
  .layout--square-3h .layout__box {
    width: 120px;
    height: 30%;
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  /** Layout SQUARE-1H2S CSS */
  .layout--square-1h2s .layout__box {
    height: 45%;
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  .layout--square-1h2s .layout__box--one {
    width: 100%;
  }

  .layout--square-1h2s .layout__box--two,
  .layout--square-1h2s .layout__box--three {
    width: 46.5%;
  }

  /** Layout SQUARE-4S CSS */
  .layout--square-4s .layout__box {
    height: 45%;
    width: 46.5%;
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  /** Layout SQUARE-1v3s CSS */
  .layout--square-1v3s .layout__content {
    flex-direction: column;
  }

  .layout--square-1v3s .layout__box {
    height: 100%;
    background-color: var(--amityeko-color-gray-8);
    border: 2px solid var(--amityeko-color-font-light);
  }

  .layout--square-1v3s .layout__box--one {
    width: 65%;
    height: 100%;
  }

  .layout--square-1v3s .layout__box--two,
  .layout--square-1v3s .layout__box--three,
  .layout--square-1v3s .layout__box--four {
    width: 30%;
    height: 30%;
  }
`;
